import api from './authService';

export const personnelService = {
  getManagers: async () => {
    const response = await api.get('/personnel/managers');
    return response.data;
  },

  assignManager: async (openProjectUserId, managerId) => {
    const response = await api.post('/personnel/managers', { openProjectUserId, managerId });
    return response.data;
  }
};
